// extracted by mini-css-extract-plugin
export default {"button":"UpButton_button__kWTev","flareAnimation":"UpButton_flareAnimation__kZ7XS"};